import { render, staticRenderFns } from "./edito-list.vue?vue&type=template&id=eb811b0c"
import script from "./edito-list.vue?vue&type=script&lang=js"
export * from "./edito-list.vue?vue&type=script&lang=js"
import style0 from "./edito-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default})
